import React from 'react';
import {BrowserRouter as Router,Routes,Route,Link} from "react-router-dom";
function ShopCard(props) {
    return (
        <div className="ShopCard">
            <img src={props.img} alt="" />
            <h1>{props.name}</h1>
            <h2>{props.desc}</h2>
            <h1>Price: Rs {props.price}</h1>
           <a href={props.number}> <button style={{background:"#2ADA13",width:"10rem",padding:"10px",borderRadius:"4px"}}>Contact</button></a>
        </div>
    )
}

export default ShopCard
